<script setup lang="ts">
import { computed, ref, watch } from 'vue'

import type { Aspect, Slide } from '../types'

const props = withDefaults(defineProps<{
  src?: string | null
  slide?: Slide | null
  aspect?: Aspect
  alt?: string
  eager?: boolean
}>(), {
  src: null,
  slide: null,
  aspect: '16:9',
  alt: 'Слайд презентации',
  eager: false,
})

const failed = ref(false)

watch(() => props.src, () => {
  failed.value = false
})

const ratio = computed(() => {
  if (props.aspect === '4:3') return '4 / 3'
  if (props.aspect === '9:16') return '9 / 16'
  return '16 / 9'
})

const fallbackTitle = computed(() => {
  const content = props.slide?.content
  if (!content) return 'Слайд готовится'
  for (const key of ['title', 'quote', 'body', 'caption']) {
    const value = content[key]
    if (typeof value === 'string' && value.trim()) return value
  }
  return 'Слайд готовится'
})
</script>

<template>
  <div class="slide-preview" :style="{ aspectRatio: ratio }">
    <img
      v-if="src && !failed"
      :src="src"
      :alt="alt"
      :loading="eager ? 'eager' : 'lazy'"
      draggable="false"
      @error="failed = true"
    >
    <div v-else class="slide-preview__fallback">
      <span class="slide-preview__shine"></span>
      <strong>{{ fallbackTitle }}</strong>
      <small>{{ src ? 'Превью обновляется' : 'Рендерим изображение' }}</small>
    </div>
    <slot></slot>
  </div>
</template>
